"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3981],{

/***/ 3981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9741);







function Footer(param) {
    var loc = param.loc, address = param.address, email = param.email, phone = param.phone;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), push = ref.push, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(new Date().getFullYear()), year = ref1[0], setYear = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // Pastikan tahun selalu update di client side
        var currentYear = new Date().getFullYear();
        if (year !== currentYear) {
            setYear(currentYear);
        }
    }, [
        year
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        direction: "column",
        as: "footer",
        bg: "black",
        py: 10,
        gap: 10,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                flexDir: {
                    base: "column",
                    lg: "row"
                },
                justify: {
                    base: "initial",
                    lg: "space-between"
                },
                mb: 2,
                w: "100%",
                gap: 12,
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                        flex: 9,
                        align: "center",
                        gap: 2,
                        justify: {
                            base: "space-between",
                            lg: "initial"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                mr: 6,
                                maxW: [
                                    24,
                                    120
                                ],
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    objectFit: "contain",
                                    src: "https://backend.parador-hotels.com/wp-content/uploads/2023/05/PHR-Logo-Parador-White.webp",
                                    alt: "Parador_White",
                                    cursor: "pointer",
                                    onClick: function() {
                                        return push("/");
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                maxW: 14,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    objectFit: "contain",
                                    src: "https://backend.parador-hotels.com/wp-content/uploads/2022/04/Atria-Logo.png",
                                    alt: "Atria-Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                maxW: 14,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    objectFit: "contain",
                                    src: "https://backend.parador-hotels.com/wp-content/uploads/2022/04/Vega-Logo.png",
                                    alt: "Vega-Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                maxW: 14,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    objectFit: "contain",
                                    src: "https://backend.parador-hotels.com/wp-content/uploads/2022/04/Fame-Logo.png",
                                    alt: "Fame-Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                maxW: 14,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    objectFit: "contain",
                                    src: "https://backend.parador-hotels.com/wp-content/uploads/2022/04/Starlet-Logo.png",
                                    alt: "Starlet-Logo"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                        flex: 9,
                        justify: {
                            lg: "flex-end",
                            base: "center"
                        },
                        align: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                            fontSize: [
                                "md",
                                "xl",
                                "2xl"
                            ],
                            color: "white",
                            fontWeight: 400,
                            letterSpacing: "4px",
                            children: "WITH A CONSCIOUS HEART"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                w: {
                    lg: "100%",
                    base: "100vw"
                },
                h: {
                    base: 100,
                    lg: "unset"
                },
                display: {
                    base: "none",
                    lg: "initial"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                    src: "https://backend.parador-hotels.com/wp-content/uploads/2022/04/Parador-Pattern-1.png",
                    alt: "Parador-Pattern"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                mx: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                // flexDir={!isLarge && `column`}\
                justify: {
                    lg: "space-between",
                    base: "flex-start"
                },
                gap: {
                    base: 8,
                    lg: 0
                },
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: locale == "id" ? "lokasi kami" : "our location",
                        list: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                mb: 8,
                                href: loc !== null && loc !== void 0 ? loc : "https://goo.gl/maps/ts41ZxoKT3hBSiZy5",
                                isExternal: true,
                                children: address
                            }, 0),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                href: "mailto:".concat(email),
                                isExternal: true,
                                children: email
                            }, 1),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                href: "tel:".concat(phone),
                                isExternal: true,
                                children: phone
                            }, 2), 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: locale == "id" ? "grup kami" : "our group",
                        list: locale == "id" ? listOurGrup.id : listOurGrup.en
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: locale == "id" ? "halaman" : "page",
                        list: locale == "id" ? listPage.id : listPage.en
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: "sitemap",
                        list: locale == "id" ? listSitemap.id : listSitemap.en
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isRow: true,
                        title: locale == "id" ? "Tetap Terhubung" : "stay connected",
                        list: listSocial
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                mx: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                    mt: 3,
                    borderWidth: 0.5,
                    py: 0.1,
                    opacity: 0.2,
                    borderColor: "white",
                    bg: "white",
                    orientation: "horizontal"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                mx: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                justify: {
                    lg: "space-between",
                    base: "flex-start"
                },
                gap: {
                    base: 8,
                    lg: 0
                },
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Atria Hotel",
                        list: [
                            "Gading Serpong",
                            "Magelang",
                            "Malang"
                        ],
                        target: [
                            "atria-hotel-gading-serpong",
                            "atria-hotel-magelang",
                            "atria-hotel-malang", 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Atria residences",
                        list: [
                            "Gading Serpong"
                        ],
                        target: [
                            "atria-residences-gading-serpong"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Vega Hotel",
                        list: [
                            "Gading Serpong"
                        ],
                        target: [
                            "vega-hotel-gading-serpong"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Fame Hotel",
                        list: [
                            "Gading Serpong",
                            "Sunset Road"
                        ],
                        target: [
                            "fame-hotel-gading-serpong",
                            "fame-hotel-sunset-road"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Starlet Hotel",
                        list: [
                            "Jakarta Airport",
                            "BSD City",
                            "Serpong"
                        ],
                        target: [
                            "starlet-hotel-jakarta-airport",
                            "starlet-hotel-bsd-city",
                            "starlet-hotel-serpong", 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                my: 6,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    color: "whiteAlpha.800",
                    fontSize: "sm",
                    children: [
                        locale == "id" ? "Hak Cipta Dilindungi" : "Copyright",
                        " \xa9 ",
                        year
                    ]
                })
            })
        ]
    });
};
function FooterList(param) {
    var title = param.title, list = param.list, isRow = param.isRow, target = param.target, _isHotel = param.isHotel, isHotel = _isHotel === void 0 ? false : _isHotel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        direction: "column",
        maxW: {
            lg: "15%",
            base: "100%"
        },
        mb: {
            base: 6,
            lg: 0
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                color: "whiteAlpha.600",
                fontSize: "md",
                mb: 4,
                fontWeight: 500,
                as: "h4",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                color: "whiteAlpha.800",
                listStyleType: "none",
                m: 0,
                style: isRow && {
                    display: "flex",
                    gap: 20
                },
                children: list.map(function(item, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HCh, {
                        fontSize: "sm",
                        mb: 2,
                        children: isHotel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/".concat(target[i]),
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                children: item
                            })
                        }) : item
                    }, i);
                })
            })
        ]
    });
}
var listSocial = [
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "https://www.instagram.com/paradorhotels",
        _hover: {
            color: "red.300"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoLogoInstagram */ .oVe, {
            size: 32
        })
    }, 0),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "https://www.facebook.com/ParadorHotelsGroup/",
        _hover: {
            color: "facebook.400"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoLogoFacebook */ .egd, {
            size: 32
        })
    }, 1), 
];
var listOurGrup = {
    en: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Homepage"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "About Us"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Our Brands"
            })
        }, 2),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Our Collections"
            })
        }, 3),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Development"
            })
        }, 4),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/gallery",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Media"
            })
        }, 5), 
    ],
    id: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Halaman Depan"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Tentang Kami"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Merek Kami"
            })
        }, 2),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/gallery",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Koleksi Kami"
            })
        }, 3),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Pengembangan"
            })
        }, 4),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/gallery",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Media"
            })
        }, 5), 
    ]
};
var listLocation = [
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        mb: 8,
        href: "https://goo.gl/maps/ts41ZxoKT3hBSiZy5",
        isExternal: true,
        children: "Soho Office Park Kav. 9, 3rd Floor, Jl. Boulevard Raya Gading, Serpong, Tangerang, Banten 15810"
    }, 0),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "mailto:hello@parador-hotel.com",
        isExternal: true,
        children: "hello@parador-hotel.com"
    }, 1),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "tel:+6229171111",
        isExternal: true,
        children: "(+62) 2917 - 1111"
    }, 2), 
];
var listPage = {
    en: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/special-offers",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Special Offers"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/wedding",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Wedding"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/meeting-events",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Meeting & Events"
            })
        }, 2),
        // <NextLink key={4} passHref href={`https://www.shop.parador-hotels.com/`}>
        //   <Link _focus={{}}>Store</Link>
        // </NextLink>,
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/blog",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Blog"
            })
        }, 5),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/contact",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Contact Us"
            })
        }, 6),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/faq",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Faq"
            })
        }, 7), 
    ],
    id: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/special-offers",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Promo Spesial"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/wedding",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Pernikahan"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/meeting-events",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Rapat & Acara"
            })
        }, 2),
        // <NextLink key={4} passHref href={`https://www.shop.parador-hotels.com/id/`}>
        //   <Link _focus={{}}>Toko</Link>
        // </NextLink>,
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/blog",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Blog"
            })
        }, 5),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/contact",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Kontak"
            })
        }, 6),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/faq",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Faq"
            })
        }, 7), 
    ]
};
var listSitemap = {
    en: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/help-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Offers Help Center"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "https://parador-hotels.com/special-offers/group",
            isExternal: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Why Book Direct"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/privacy-policy",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Privacy & Policy"
            })
        }, 2),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/career",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Career"
            })
        }, 3), 
    ],
    id: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/help-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Pusat Bantuan"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "https://parador-hotels.com/special-offers/group",
            isExternal: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Kenapa Pesan Langsung"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/privacy-policy",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Privasi & Kebijakan"
            })
        }, 2),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "https://parador-hotels.com/",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Karir"
            })
        }, 3), 
    ]
};


/***/ })

}]);